import jsPDF from "jspdf";
import "jspdf-autotable";

const generateReceipt = (data) => {
    const doc = new jsPDF();

    // Header
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("RECEIPT", 105, 20, { align: "center" });

    // Paid Stamp
    doc.setFont("helvetica", "bold");
    doc.setFontSize(40);
    doc.setTextColor(255, 0, 0); // Red color
    doc.text("PAID", 105, 70, { align: "center", angle: -30 });

    // Company Information
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("From,", 14, 30);
    doc.setFont("helvetica", "bold");
    doc.text("Adspace LLC", 14, 35);
    doc.setFont("helvetica", "normal");
    doc.text(
        `Patricio Sanz 1701 Del Valle CDMX, Mexico`,
        14,
        40
    );
    doc.text("EMAIL: adspace.officials@gmail.com", 14, 55);

    // Client Information
    doc.setFont("helvetica", "normal");
    doc.text("To,", 140, 30);
    doc.setFont("helvetica", "bold");
    doc.text(data.publisherName || "", 140, 35); // fallback to empty if null
    doc.setFont("helvetica", "normal");
    doc.setFont("helvetica", "normal");
    doc.text(data.publisherAddress || "", 140, 40); // fallback to empty if null


    // Receipt Details
    doc.setFontSize(10);
    doc.text(`Invoice Number: ${data.id || ""}`, 14, 80);
    doc.text(`Invoice Date: ${new Date(data.invoiceDate)
        .toLocaleDateString("en-GB") // gives "01/03/2025"
        .replace(/\//g, "-")}`, 14, 85);

    const currentMonth = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    doc.text(`Revenue Month: ${currentMonth}`, 14, 90);

    // Table Data
    const tableColumn = ["Description", "Qty", "Deduction (US$)", "Amount (US$)"];
    const tableRows = [
        [
            data.description,
            "1",
            `${data.deductions || 0}`,  // Deduction
            `${data.revenue || 0}`     // Amount
        ],
    ];

    doc.autoTable({
        startY: 100,
        head: [tableColumn],
        body: tableRows,
        theme: "grid",
        styles: { halign: "center" },
    });

    // Footer Total Section
    const finalY = doc.lastAutoTable.finalY || 120;

    // For clarity, you can decide how to calculate totals:
    // e.g., subTotal = revenue, grandTotal = revenue - deductions, etc.
    const revenue = Number(data.revenue || 0);
    const deductions = Number(data.deductions || 0);
    const subTotal = revenue;              // if you want subTotal as the raw revenue
    const grandTotal = revenue - deductions;

    doc.setFont("helvetica", "bold");
    doc.text("Sub Total:", 160, finalY + 10, { align: "right" });
    doc.text(`${subTotal.toFixed(2)}`, 200, finalY + 10, { align: "right" });

    doc.text("Grand Total:", 160, finalY + 20, { align: "right" });
    doc.text(`${grandTotal.toFixed(2)}`, 200, finalY + 20, { align: "right" });

    // Footer Note
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
        `For ${data.publisherName}
Thank you for your payment. This receipt is system-generated and does not require a signature.`,
        14,
        finalY + 40
    );

    doc.setFont("helvetica", "bold");
    doc.text("Bank Details:", 14, finalY + 50);
    doc.setFont("helvetica", "normal");
    doc.text(
        `Bank Name: ${data.bankName || ""}
Bank Account #: ${data.bankAccountNumber || ""}
Bank Branch: ${data.bankBranch || ""}
Swift Code: ${data.swiftCode || ""}`,
        14,
        finalY + 55
    );
    // Save PDF
    doc.save("Receipt.pdf");
};

export default generateReceipt;